import React from "react";
import { createPortal } from "react-dom";
import "./styles.css";
import { vector } from "../../assets/images";
import { X } from "react-bootstrap-icons";

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  title?: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  onClose,
  message,
  title = "OOPS!",
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="error-modal-overlay">
      <div className="error-modal-container scale-in">
        <button className="error-modal-close-btn" onClick={onClose} aria-label="Close">
          <X size={24} />
        </button>

        <div className="error-modal-content">
          <div className="error-modal-icon-wrapper">
            <img
              src={vector}
              alt="Error"
              className="error-modal-icon"
            />
          </div>

          <h3 className="error-modal-title">{title}</h3>
          <p className="error-modal-message">{message}</p>

          <div className="error-modal-footer">
            <button className="error-modal-ok-btn" onClick={onClose}>
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ErrorModal;
